module.exports = __webpack_public_path__ + "img/abstract2.d58cf54b.png";